import React from "react";
import PageTop from "../../common/PageTop/PageTop";
import Footer from "../../common/Footer/Footer";
import Details from "./Details/Details";
import EnquiryForm from "./EnquiryForm/EnquiryForm";
import Nav from "../Home/Nav/Nav";
import aboutimage from "../../../assets/images/ogcontact.jpg";

const Contact = () => {
  return (
    <>
      <Nav />
      <PageTop title={"Contact"} image={aboutimage} />
      <Details />
      <EnquiryForm />
      <div
        style={{
          width: "100%",
        }}
      >
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2479.3536000869126!2d-0.32430945977734177!3d51.58008247194716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48761398fc2681b9%3A0xdc7939bf58d2f4c4!2s68%20Kenton%20Rd%2C%20Harrow%20HA3%208AB%2C%20UK!5e0!3m2!1sen!2sin!4v1786556181829!5m2!1sen!2sin"
          title="Company location on Google Maps"
          width="100%"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
